import React from 'react';
import VertNavBar from 'components/VertNavBar/VertNavBar';
import { Bookmark, NavigationData, Report } from 'core/slices/models';
import './SidebarMenu.scss';

type SidebarMenuProps = {
  showSidebar: boolean;
  navData: NavigationData | null;
  handleReportClick: (report: Report) => void;
  handleBookmarkClick: (bookmark: Bookmark) => void;
  activeReport: Report | undefined;
};

export const SidebarMenu: React.FC<SidebarMenuProps> = ({
  showSidebar,
  navData,
  handleReportClick,
  handleBookmarkClick,
  activeReport,
}) => {
  if (!showSidebar) return null;

  return (
    <div className="nav-container">
      <VertNavBar
        navigationData={navData}
        onReportClick={handleReportClick}
        onBookmarkClick={handleBookmarkClick}
        activeReport={activeReport}
      />
    </div>
  );
};
